import type { PublicPluginAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/useSharedPluginStateSelector';
import type { CollabEditPlugin } from '@atlaskit/editor-plugin-collab-edit/collabEditPluginType';
import type { ConnectivityPlugin } from '@atlaskit/editor-plugin-connectivity/connectivityPluginType';

import type { AIPlugin } from '@atlassian/editor-plugin-ai/aiPluginType';

import type { ConflictResolutionUIPlugin } from '@confluence/editor-presets/entry-points/presets/conflictResolutionUIPlugin.ts';

export type EditorPresetAPI =
	| PublicPluginAPI<[CollabEditPlugin, ConnectivityPlugin, ConflictResolutionUIPlugin, AIPlugin]>
	| null
	| undefined;

export const useSharedAIState: (_api: EditorPresetAPI) => {
	aiIsStreaming: boolean;
} = (api: EditorPresetAPI) => {
	const aiIsStreaming =
		useSharedPluginStateSelector(api, 'aiExperience.isStreaming', {
			disabled: !api,
		}) ?? false;
	return { aiIsStreaming };
};
